// DEPENDENCIES //
import { Routes, Route } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

// PAGES //
import About from "./pages/About";
import Warning from "./pages/Warning";
import Chase from "./pages/Chase";
import CreateZombie from "./pages/CreateZombie";
import Fight from "./pages/Fight";
import LogIn from "./pages/LogIn";
import Home from "./pages/Home";
import Outcome from "./pages/Outcome";
import ShowZombie from "./pages/ShowZombie";
import SignUp from "./pages/SignUp";

// COMPONENTS //
import PixiBrushBackground from "./components/PixiBrushBackground";
import Footer from "./components/Footer";
// import { showRoute, getCurrentUser } from "./utils/api";

// CSS //
import "./App.css";

// MUSIC //
import themeMusic from "./assets/dreamland_humans_win.mp3";
import WakeButton from "./components/WakeButton";
import { getZombieById } from "./utils/api";


function App() {

  // ASPECT RATIO //
  const DESIGN_WIDTH = 2390;
  const DESIGN_HEIGHT = 1000;

  const [scale, setScale] = useState(1);

  const audioRef = useRef(null);

  // const MUSIC_ENABLED = false;

  // START MUSIC //
  function startMusic() {

    // if (!MUSIC_ENABLED) return;
    
    if (!audioRef.current) {
      audioRef.current = new Audio(themeMusic);
      audioRef.current.loop = true;
      audioRef.current.volume = 0.35;
    }

    audioRef.current.play();
  }

  // STOP MUSIC //
  function stopMusic() {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  }

  useEffect(() => {
    function updateScale() {
      const scaleX = window.innerWidth / DESIGN_WIDTH;
      const scaleY = window.innerHeight / DESIGN_HEIGHT;
      setScale(Math.min(scaleX, scaleY));
    }

    updateScale();
    window.addEventListener("resize", updateScale);
  }, []);

  // STATE //
  const [zombie, setZombie] = useState({})


  // LOCAL STORAGE ZOMBIE //
  useEffect(() => {
    const savedZombieId = localStorage.getItem("currentZombieId");

    if (savedZombieId && !zombie?._id) {
      getZombieById(savedZombieId)
        .then((data) => {
          if (data) {
            setZombie(data);
          } else {
            localStorage.removeItem("currentZombieId");
          }
        })
        .catch(() => {
          localStorage.removeItem("currentZombieId");
        });
    }
  }, []);



  return (
    <div className="App">
      <div
        className="game-frame"
        style={{
          width: `${DESIGN_WIDTH * scale}px`,
          height: `${DESIGN_HEIGHT * scale}px`
        }}
      >
        <div
          className="game-window"
          style={{ transform: `scale(${scale})` }}
        >
          <PixiBrushBackground />

          <main className="game-content">
            <Routes>

              <Route path="/" element={<Home startMusic={startMusic} />} />

              <Route path="/warning" element={<Warning stopMusic={stopMusic} />} />

              <Route path="/about" element={<About startMusic={startMusic} />} />

              <Route path="/createzombie" element={<CreateZombie setZombie={setZombie} stopMusic={stopMusic} />} />

              <Route path="/showzombie" element={<ShowZombie zombie={zombie} setZombie={setZombie} stopMusic={stopMusic}/>} />

              <Route path="/chase" element={<Chase zombie={zombie} setZombie={setZombie} stopMusic={stopMusic} />} />

              <Route path="/fight" element={<Fight zombie={zombie} setZombie={setZombie} stopMusic={stopMusic}/>} />

              <Route path="/outcome" element={<Outcome zombie={zombie} setZombie={setZombie} stopMusic={stopMusic} />} />

            </Routes>
          </main>

        </div>
      </div>
    </div>
  );
}

export default App;
